export default "__VITE_ASSET__BaDl8Au4__"